import ConstructionRounded from '@mui/icons-material/ConstructionRounded';
import { Card } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { EmptyState, PageHeader } from '../components/states';
import { NAV } from '../layout/nav';

/** Placeholder for screens built in later Phase 2 milestones. */
export function ComingSoonPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const item = NAV.flatMap((g) => g.items).find(
    (i) => i.path !== '/' && pathname.startsWith(i.path),
  );
  return (
    <>
      <PageHeader title={item?.label ?? 'Not found'} />
      <Card>
        <EmptyState
          icon={<ConstructionRounded />}
          title={item ? 'This screen is on its way' : 'Page not found'}
          body={
            item
              ? `${item.label} arrives in milestone ${item.milestone ?? ''} of the web app. The backend for it is already live.`
              : 'The page you were looking for does not exist.'
          }
          action={{ label: 'Back to dashboard', onClick: () => void navigate('/') }}
        />
      </Card>
    </>
  );
}
